
import * as types from "./action-type";

export const setselectedWITN = (data: any) => ({
  type: types.SET_SELECTED_WITN,
  data,
});

export const SetWIExportDataFlag = (dispatch: any, data: boolean) => {
  dispatch({ type: types.EXPORT_WORKITEM_LIST, data });
};

export const setQuickFilterAction = (dispatch: any, data: any) => {
  dispatch({ type: types.SET_QUICK_FILTERS, data });
}

export const setNavigationStateAction = (dispatch: any, data: boolean) => {
  dispatch({
    type: types.SET_NAVIGATION_STATE,
    data,
  });
};

